import React from 'react';
import './App.css';

import { Segment, Header, Divider, Icon, Popup, Grid } from 'semantic-ui-react'; 

class Demo extends React.Component {

    constructor() {
        super();

        this.state = {
            isOpen: false
        }

        this.onOpen = this.onOpen.bind(this);
    }

    onOpen(event) {
        this.setState({ isOpen: true });
    }

    render() {

        let visible;

        if (this.state.isOpen) {
            visible = <Segment basic textAlign="left">
                       <Header as="h1">Chapter 1</Header>
                       <p>The house stood on a slight rise just on the edge of the village. It stood on its own and...</p>
                </Segment>
         } else {
            visible = <Segment basic textAlign="center">
                <em>click on the user icon to see what happens</em>
                </Segment>
       }
        return (                            
            <Grid.Column className="demo">
                <Popup trigger={<Icon name='user' size='huge' />} 
                    position="top center"
                    on="click"
                    open={ this.state.isOpen }
                    onOpen={ this.onOpen } 
                    onClose={ this.onOpen } >
                    <Popup.Content>
                        <q>new chapter chapter 1 the house stood on a slight rise just on the edge of the village it stood on its own and...</q>
                    </Popup.Content>
                </Popup>

                <Divider horizontal>becomes</Divider>

                { visible }
            </Grid.Column>
        );
    }
}

export { Demo };




// WEBPACK FOOTER //
// ./src/Demo.js